import { createConfirmation } from "react-confirm";
import AddBaseUnitDialog from "./AddBaseUnitDialog";

export const showAddBaseUnitDialog = createConfirmation(AddBaseUnitDialog);
